// Withdrawal
export const PLATFORM_WITHDRAWAL_FEE = 0
export const PLATFORM_WITHDRAWAL_FEE_CURRENCY = 'USD'
